import Calendar from "app/Components/Calendar/Calendar";
import BackBtn from "app/Components/CommanComponents/BackBtn";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import { SITE_TYPE } from "app/_constants/constant";
import { formatDDMMYYYYbyYYYYMMDD } from "app/_helpers/helper";
import { getVFL } from "app/_services/ehs/VFLService";
import React, { useEffect, useMemo, useState } from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
// import "app/globals/components/_calendar.scss";
import { getStatusClass } from "../ComplianceRegister/CONSTANT";
import { ACTIVE_MODULE } from "app/_constants/constant";
import {
  isUserMM,
  isUserSO,
  isUserVFLOfficer,
  IS_USER_SITE_HO,
  LOGGED_IN_USER_SITE_ID,
  LOGGED_USER_ID,
} from "../IncidentManagement/Helper";
import { getVFLStatusClass, VFL_STATUS, VFL_STATUS_VIEW } from "./CONSTANTS";
// import "app/globals/components/calendar.scss";

const initialFilter = {
  vflStatus: "All",
};

const EventInfoModal = ({ title, start, show, onHide, form }) => (
  <Modal className="calenderModel" show={show} onHide={onHide}>
    <Modal.Header closeButton className="bg-primary text-white">
      <Modal.Title>Visual Felt Leadership Details </Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {/* <div>
        <label className="mr-2">Scheduled Date:</label>
        <span>{title}</span>
      </div> */}
      <div className="calPopupRow">
        <label className="mr-2">VFL ID:</label>
        <span>{form?.vflId}</span>
      </div>
      <div className="calPopupRow">
        <label className="mr-2">Scheduled Date:</label>
        <span>{formatDDMMYYYYbyYYYYMMDD(form?.vflScheduledDateTime)}</span>
      </div>

      <div className="calPopupRow">
        <label className="mr-2">Executive Name:</label>
        <span>{`${form?.vflOfficerData?.firstName} ${form?.vflOfficerData?.lastName}`}</span>
      </div>
      <div className="calPopupRow">
        <label className="mr-2">Executive Email:</label>
        <span>{`${form?.vflOfficerData?.email}`}</span>
      </div>
      <div className="calPopupRow">
        <label className="mr-2">Area of Operation:</label>
        <span>{form?.ehs_area_of_operations?.name}</span>
      </div>
      <div className="calPopupRow">
        <label className="mr-2">VFL Description:</label>
        <span className="full">{form?.description}</span>
      </div>
    </Modal.Body>
  </Modal>
);

function Event({ event, timeText }) {
  const [show, setShow] = useState(false);

  const onHide = () => setShow(false);

  console.log("event", event);
  console.log("timeText", timeText);

  return (
    <>
      <div onClick={() => setShow(true)} className="w-100 pointer">
        <span
          style={{ height: 10, width: 15 }}
          className={`${getStatusClass(event?.extendedProps?.eventStatus)} mr-2`}
        />
        {/* <b className="mr-1">{timeText.toUpperCase()}M</b> */}
        <span
          className={`${getVFLStatusClass(event?.extendedProps?.form?.vflStatus)} pl-1`}
        >
          {event.title}
        </span>
      </div>
      {show && <EventInfoModal show={show} onHide={onHide} {...event.extendedProps} />}
    </>
  );
}

function VFLCalendar() {
  const [filter, setFilter] = useState({ ...initialFilter });
  const [tab, setTab] = useState(4);

  const [VFLList, setVFLList] = useState([]);
  const onChange = ({ target: { name, value } }) =>
    setFilter((prev) => ({ ...prev, [name]: value }));

  const events = useMemo(
    () =>
      VFLList.filter((row) => {
        if (tab === 4) {
          if (filter.vflStatus === "All") return true;
          if (row.vflStatus === filter.vflStatus) {
            return true;
          }
        }

        // let editLink = false;
        // if (row.vflStatus) {
        //   if (row.vflStatus === "scheduled" && isUserMM()) {
        //     editLink = "/health-safety-and-environment/vfl/schedule/" + row.id;
        //   } else if ([VFL_STATUS.assigned, VFL_STATUS.executed].includes(row.vflStatus) && isUserVFLOfficer()) {
        //     editLink = "/health-safety-and-environment/vfl/completion/" + row.id;
        //   }
        // }

        let flag = false;
        if (row.vflStatus) {
          if (
            tab === 2 &&
            row.vflStatus === "scheduled" &&
            isUserMM() &&
            ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
              (row.vflAssignerSiteType === SITE_TYPE.mines &&
                LOGGED_IN_USER_SITE_ID() === row.mineId))
          ) {
            flag = true;
          } else if (
            tab === 3 &&
            [VFL_STATUS.assigned, VFL_STATUS.executed].includes(row.vflStatus) &&
            isUserVFLOfficer() &&
            LOGGED_USER_ID() === row.vflExecutiveId
          ) {
            flag = true;
          } else if (
            tab === 1 &&
            row.vflStatus === VFL_STATUS.capaCompleted &&
            isUserSO() &&
            ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
              (row.vflAssignerSiteType === SITE_TYPE.mines &&
                LOGGED_IN_USER_SITE_ID() === row.mineId))
          ) {
            flag = true;
          } else if (
            tab === 2 &&
            row.vflStatus === VFL_STATUS.capaReviewed &&
            isUserMM() &&
            ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
              (row.vflAssignerSiteType === SITE_TYPE.mines &&
                LOGGED_IN_USER_SITE_ID() === row.mineId))
          ) {
            flag = true;
          } else if (
            tab === 1 &&
            row.vflStatus === VFL_STATUS.draft &&
            isUserSO() &&
            ((row.vflAssignerSiteType === SITE_TYPE.ho && IS_USER_SITE_HO()) ||
              (row.vflAssignerSiteType === SITE_TYPE.mines &&
                LOGGED_IN_USER_SITE_ID() === row.mineId))
          ) {
            flag = true;
          }
        }

        return flag;
      }).map((vfl) => ({
        id: vfl.vflId,
        title: `${vfl.vflId.substring(0, 12)}...`,
        start: vfl.vflScheduledDateTime,
        extendedProps: {
          title: vfl.vflId,
          start: vfl.vflScheduledDateTime,
          form: vfl,
        },
      })),
    [VFLList, filter.vflStatus, tab]
  );

  useEffect(() => {
    getVflList();
  }, []);

  const getVflList = () => {
    getVFL().then((response) => {
      if (!response?.status) return;

      setVFLList(response.data);
    });
  };

  function renderEventContent({ event, timeText }) {
    return <Event event={event} timeText={timeText} />;
  }
  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Visible Felt Leadership",
            path: "/health-safety-and-environment/vfl",
          },
          { name: "Calendar" },
        ]}
        module={ACTIVE_MODULE.vfl}
      />
      <div className="card p-3">
        <div className="simple-card-title cardCustomHeader">
          <h3 class="text-capitalize mb-0">Calendar</h3>
          <BackBtn url={"/health-safety-and-environment/vfl"} />
        </div>

        <div className="healthSafetyEnvironmentWrapper EHS_module_tabber">
          <div className="hseMenuLinks card">
            <a
              href
              onClick={() => setTab(4)}
              className={`pointer${tab === 4 ? " active" : ""}`}
            >
              All
            </a>

            {isUserSO() && (
              <a
                href
                onClick={() => setTab(1)}
                className={`pointer${tab === 1 ? " active" : ""}`}
              >
                Safety Officer
              </a>
            )}

            {isUserMM() && (
              <a
                href
                onClick={() => setTab(2)}
                className={`pointer${tab === 2 ? " active" : ""}`}
              >
                Mines Manager
              </a>
            )}
            {isUserVFLOfficer() && (
              <a
                href
                onClick={() => setTab(3)}
                className={`pointer${tab === 3 ? " active" : ""}`}
              >
                VFL Executive
              </a>
            )}
          </div>
        </div>

        <div className="mt-3">
          {/*  <div className="d-flex justify-content-between  simple-card-title">
          <h3 className="  text-capitalize mb-0">Calendar</h3>

          <div className="d-flex justify-content-between">
            <div className="pr-3">
              <label className="radio radio-primary form-check-inline mr-3">
                <input
                  type="radio"
                  name={"VFLStatus"}
                  value="All"
                  onChange={onChange}
                  checked={filter.VFLStatus === "All"}
                />
                <span>All</span>
                <span className="checkmark"></span>
              </label>
            </div>

            <div className="pr-3">
              <label className="radio radio-primary form-check-inline mr-3">
                <input
                  type="radio"
                  name={"VFLStatus"}
                  value="my"
                  onChange={onChange}
                  checked={filter.VFLStatus === "my"}
                />
                <span>MY VFL</span>
                <span className="checkmark"></span>
              </label>
            </div>
          </div>
        </div> */}

          {tab === 4 && (
            <Row className="searchIncident">
              <Col lg={12}>
                <div className="incidentRadioInner">
                  <div className="incidentCols">
                    <label className="customIncidentRadio">
                      <input
                        type="radio"
                        name={"vflStatus"}
                        value="All"
                        onChange={onChange}
                        checked={filter.vflStatus === "All"}
                      />
                      <span className="labelTxt">All</span>
                      <span className="checkmark"></span>
                    </label>
                  </div>
                  {Object.keys(VFL_STATUS).map((key) =>
                    key === "draft" || !VFL_STATUS_VIEW[VFL_STATUS[key]] ? null : (
                      <div key={key} className="incidentCols">
                        <label className="customIncidentRadio">
                          <input
                            type="radio"
                            name={"vflStatus"}
                            value={VFL_STATUS[key]}
                            onChange={onChange}
                            checked={filter.vflStatus === VFL_STATUS[key]}
                          />
                          <span className="labelTxt">
                            {VFL_STATUS_VIEW[VFL_STATUS[key]]}
                          </span>
                          <span className="checkmark"></span>
                        </label>
                      </div>
                    )
                  )}
                </div>
              </Col>
            </Row>
          )}

          <div className="ehsFormWrapper">
            <Calendar events={events} renderEventContent={renderEventContent} />
          </div>
        </div>
      </div>
    </>
  );
}

export default VFLCalendar;
